import {Component} from '@angular/core';
import {Role} from 'src/app/models/role';
import {SettingsService, RoleMenu} from 'src/app/pages/settings/settings.service';
import {AuthService, RolePermission} from 'src/app/services';
import {DropdownValues} from '../dropdown/dropdown.component';
import {AdvanceDashboardService, DashboardAccess} from 'src/app/pages/bi-dashboard/dashboard.service';
import {NotificationService} from 'src/app/services/notification.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
	selector: 'app-dashboard-access-control',
	templateUrl: './dashboard-access-control.component.html',
	standalone: false,
})
export class DashboardAccessControlComponent {
	constructor(
		private readonly authService: AuthService,
		private readonly settingsService: SettingsService,
		private readonly localStorageService: LocalStorageService,
		private readonly dashboardService: AdvanceDashboardService,
		private readonly notificationService: NotificationService,
	) { }

	ngOnInit() {
		this.getRoles('pageLoad');
	}

	roles: Role[] = [];
	selectedRoleId: number;

	rolesDropdown: DropdownValues = new DropdownValues();
	menuItems: RoleMenu[] = [];

	dashboardItems = [];
	private getRoles(action: string) {
		this.settingsService.getRoles().subscribe(
			(roles) => {
				this.roles = roles;
				this.selectedRoleId = roles && roles.length ? roles[0].roleId : 0;

				if (action == 'pageLoad') {
					this.getMenuItemsByRole();
				}
			},
			(error: any) => {
				console.log(
					'****************getRoles*************************',
					error,
				);
			},
		);
	}

	expandedRowKeys = [];
	private getMenuItemsByRole() {
		if (!this.selectedRoleId) {
			this.menuItems = [];

			return;
		}

		this.dashboardService.GetDashboardsMenuAccess(this.selectedRoleId).subscribe((result) => {
			this.dashboardItems = result;
		});
	}

	public roleChanged(roleId: number) {
		this.selectedRoleId = roleId;
		this.getMenuItemsByRole();
	}

	menuDashboardItems: DashboardAccess;
	public save() {
		this.menuDashboardItems = new DashboardAccess();
		this.menuDashboardItems.Id = this.selectedRoleId;
		this.menuDashboardItems.Items = [];
		this.dashboardItems.forEach((item) => {
			this.menuDashboardItems.Items.push({
				DashboardId: item.dashboardId,
				IsActive: item.isActive,
			});
		});
		this.dashboardService.SavingDashboardsMenuAccess(
			this.menuDashboardItems,
			{showLoadingIndicator: true},
		).subscribe((result) => {
			if (result && result.length > 0 && result[0].flag != null && result[0].flag != undefined) {
				this._changeMenu();
				this.notificationService.success(result[0].msg);
			}
		});
	}

	private _changeMenu() {
		this.authService.getPermissions(
			{
				showLoadingIndicator: true,
			},
		).subscribe(
			{
				next: (permissions) => {
					this.localStorageService.set(
						RolePermission.storage_key,
						permissions,
					);
				},
			},
		);
	}
}